<template>
  <div v-loading.body="loading">
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>筛选查询</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
            >{{ filterFold ? "展开筛选" : "收起筛选" }}</el-button
          >
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-col :span="24">
                <el-form :inline="true" :model="form" class="demo-form-inline">
                  <el-form-item label="输入搜索：">
                    <el-input
                      v-model="form.tally_task_id"
                      placeholder="理货任务id"
                      @keyup.native.enter="search"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-model="form.tally_task_status"
                      placeholder="状态"
                    >
                      <el-option label="全部" value="0"></el-option>
                      <el-option
                        v-for="item in search_ops.tally_task_status"
                        :key="item.key"
                        :label="item.label"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="生成时间：">
                    <el-date-picker
                      v-model="form.create_time"
                      :default-time="['06:00:00', '06:00:00']"
                      type="datetimerange"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                    >
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item label="完成时间：">
                    <el-date-picker
                      v-model="form.complete_time"
                      :default-time="['06:00:00', '06:00:00']"
                      type="datetimerange"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                    >
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" @click="search">查询</el-button>
                  </el-form-item>
                  <el-form-item>
                    <el-button @click="reset">重置</el-button>
                  </el-form-item>
                </el-form>
              </el-col>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <!-- 表格 -->
    <el-row v-if="!loading">
      <el-col style="border: 1px solid #ddd">
        <el-row
          :span="24"
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <el-col :span="8">数据列表：</el-col>
          <el-col :span="16" style="text-align: right">
            <el-button type="success" style="" size="mini" @click="output(1)">
              导出理货任务</el-button
            >
            <el-button type="success" style="" size="mini" @click="output(2)">
              导出理货明细</el-button
            >
          </el-col>
        </el-row>
        <div v-if="resData" style="margin-bottom: 0">
          <el-table
            ref="multipleTable"
            v-loading="tableLoading"
            height="600"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
          >
            <el-table-column
              prop="tally_task_id"
              label="理货任务id"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="shipping_area"
              label="仓区"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="num"
              label="商品数量"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="tally_task_tally_task_status"
              label="状态"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="create_time"
              label="生成时间"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="start_time"
              label="开始时间"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="complete_time"
              label="完成时间"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="admin_name"
              label="理货人"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop=""
              label="操作"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="handleClick(scope.row)"
                  >详情</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper ,sizes"
            :total="resData.count"
            :page-size="form.pagesize"
            :page-sizes="[50, 100, 200, 500]"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchCondition();
    });
  },
  data() {
    return {
      resData: {
        setting: "未配置数据",
      },
      form: {
        create_time: this.searchDate(),
        pagesize: 50,
        search_type: 1,
        page: 1,
        // dbid:'',
      },
      loading: false,
      url: "/erp/TallyTask/getTallyTaskList",
      curPage: 1,
      tableLoading: false,
      filterFold: false,
      msg: "",
      search_ops: [],
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },

  // created() {
  //     this.fetchData()
  // },
  methods: {
    handleSizeChange($val) {
      this.form.pagesize = $val;
      this.fetchData(true);
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleClick(row) {
      this.$router.push(`/home/tallytask/TallyTaskDetail/${row.tally_task_id}`);
    },
    searchDate() {
      const endDate = new Date();
      endDate.setDate(endDate.getDate() + 1);
      const endM =
        endDate.getMonth() + 1 < 10
          ? `0${endDate.getMonth() + 1}`
          : endDate.getMonth() + 1;
      const end = `${endDate.getFullYear()}-${endM}-${endDate.getDate()} 06:00:00`;

      const startDate = new Date();
      startDate.setDate(startDate.getDate());
      const startM =
        startDate.getMonth() + 1 < 10
          ? `0${startDate.getMonth() + 1}`
          : startDate.getMonth() + 1;
      const start = `${startDate.getFullYear()}-${startM}-${startDate.getDate()} 06:00:00`;
      return [start, end];
    },

    output(val) {
      if (val == 1) {
        this.form.is_excel = 1;
      }
      if (val == 2) {
        this.form.is_excel_detail = 1;
      }
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.form.is_excel = 0;
        this.form.is_excel_detail = 0;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.loading = false;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        }
      });
    },

    handleCurrentChange(val) {
      this.form.page = val;
      this.fetchData(true);
    },
    search() {
      this.form.page = 1;
      this.form.is_excel = 0;
      this.fetchData(true);
    },
    fetchCondition() {
      this.$http
        .post("/erp/TallyTask/getCondition", this.filteredForm)
        .then((res) => {
          this.loading = false;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.search_ops = res.data.data;
          }
        });
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    reset() {
      this.form = {
        recheck_begin_time: this.searchDate(),
        page: 1,
        pagesize: 50,
        search_type: 1,
      };
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 12px;
}

.column {
  text-align: center;
  border: 1rpx solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.tab-div {
  border: 1px solid #ddd;
  margin: 20px 0;
  padding: 10px 0 10px 20px;
}

.tag-css {
  margin-left: 10px;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}

.el-dropdown-menu__item {
  background-color: #f56c6c;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/pages/tallytask/TallyTaskList.vue